<template>
  <div>
    <v-container>
    <v-app-bar height="60" id="nav" app :class="{change_color: scrollPosition > 50}" d-flex class="app-bar">
      <v-container>
      <v-row align="center">
        <v-app-bar-nav-icon class="mobile-view" @click="toggle"></v-app-bar-nav-icon>
      <v-spacer class="mobile-view"></v-spacer>
      <v-toolbar-title>
        <h4 class="dt-orange__text text-uppercase mobile-view">{{$route.name}}</h4>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
        <v-list color="transparent">
          <v-list-item class="list-nav">
            <v-list-item-avatar class="avatar">
              <v-img :src="profilepicture"></v-img>
            </v-list-item-avatar>
            <v-list-item-content class="web-view">
              <v-list-item-title class="name"
                ><b>{{name}}</b></v-list-item-title
              >
              <v-list-item-subtitle class="role">{{email}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-menu rounded="3" width="50" flat offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-list-item-icon>
                  <v-btn icon v-bind="attrs" v-on="on"
                    ><v-icon>mdi-chevron-down</v-icon></v-btn
                  >
                </v-list-item-icon>
              </template>
              <v-list class="pa-2" flat dense>
                <v-list-item :to="profileLink" class="pl-10 pr-10 rounded sub-link" link>
                  <v-list-item-title class="sub-link__text">My Profile</v-list-item-title>
                </v-list-item>
                 <v-list-item :href="newAdminLink" class="pl-10 pr-10 rounded sub-link" link>
                  <v-list-item-title class="sub-link__text">Switch Admin</v-list-item-title>
                </v-list-item>
                 <v-list-item @click="logout()" class="pl-10 pr-10 sub-link rounded" link>
                  <v-list-item-title class="sub-link__text red--text">Logout</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-list-item>
        </v-list>
      </div>
      </v-row>
      </v-container>
    </v-app-bar>
    </v-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as ROUTES from "@/http/routes.js";
export default {
  components:{
    
  },
  data: () => ({
    dialog:true,
    profileLink:ROUTES.PROFILE,
    mobile:true,
    scrollPosition : null,
    newAdminLink: process.env.VUE_APP_NEW_ADMIN_URL || 'https://dtunes-web.vercel.app/',
  }),
  computed:{
    ...mapState(["userDetails"]),
    name(){
      return `${this.userDetails.profile.firstname} ${this.userDetails.profile.lastname}`
    },
    profilepicture(){
      return this.userDetails.profile.profilepicture;
    },
    email(){
      return this.userDetails.email
    }
  },
  mounted() {
    this.responsive();
    window.addEventListener('scroll', this.updateScroll);
  },
 
  methods:{
    async toggle(){
      this.$emit('dialogHandler','dialog')
    },
    logout(){
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    responsive(){
      let breakpoint = 1024;
      if(screen.width >= breakpoint ){
        this.mobile = false
      }
      else if(screen.width < breakpoint){
        this.mobile = true
      }
    },
    updateScroll() {
       this.scrollPosition = window.scrollY
    }
  }
}
</script>

<style src="@/assets/Global/scss/components/app-header.scss" lang="scss" />